import { useState } from "react";
import { connect } from "react-redux";
import { setUser } from "../../../../store/action/auth";
import AuthService from "../../../../services/auth/Auth";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import { Warning } from "../../../../components/button";
import Input from "../../../../components/input/Input";
import WarningAlert from "../../../../components/alert/Warning";
import HeaderChild from "../../../../layout/app/headers/mobile/HeaderChild";
import { Container, Row, Col } from "./style";

const ConplateInformation = (props) => {
  const { user, theme, history, setUser } = props;

  const [isLoadingSendData, setIsLoadingSendData] = useState(false);
  const [state, setState] = useState({
    name: user?.data?.name ? user?.data?.name : "",
    family: user?.data?.family ? user?.data?.family : "",
  });

  const handleSubmit = () => {
    setIsLoadingSendData(true);

    HttpService(user?.token)
      .post("user/update", state)
      .then((response) => {
        var data = {
          name: state.name,
          family: state.family,
          full_name: `${state.name} ${state.family}`,
        };

        AuthService.chnage(user, data, setUser);

        Http(response?.status, response?.data?.message, props);

        onChangeRoute("/");
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingSendData(false);
      });
  };

  const handleChange = (stateName, value) => {
    var p = /^[\u0600-\u06FF\s]+$/;

    if (!p.test(value[value.length - 1])) {
      value = value.substring(0, value.length - 1);
    }

    setState({
      ...state,
      [stateName]: value,
    });
  };

  const handleBack = () => {
    AuthService.setUser("", setUser);
  };

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);
  };

  return (
    <>
      <HeaderChild headerTitle="تکمیل اطلاعات" onPress={handleBack} />
      <Container theme={theme}>
        <Row className="row no-gutters mx-1 mt-5 pt-3">
          <Col className="col-12 text-right">
            <WarningAlert>
              لطفا ابتدا نام و نام خانوادگی خود را وارد کنید.
            </WarningAlert>
          </Col>
          <Col className="col-12 text-right">
            <Input
              name="name"
              label="نام"
              value={state.name}
              onChange={handleChange}
              autocomplete="off"
            />
          </Col>
          <Col className="col-12 text-right mt-2">
            <Input
              name="family"
              label="نام خانوادگی"
              value={state.family}
              onChange={handleChange}
              autocomplete="off"
            />
          </Col>
          <Col className="col-12 text-right mt-3">
            <Warning
              className="d-block"
              isLoading={isLoadingSendData}
              sizeSpinner={20}
              title="ذخیره اطلاعات"
              onClick={handleSubmit}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser })(ConplateInformation);
